// extracted by mini-css-extract-plugin
export default {"xAxis":"residentTimeline__xAxis___[chunkhash-base64-5]"};